import React, { useState } from 'react';
import NavMenu from '../components/crm/NavMenu';
import Toasts from '../components/crm/shared/Toasts';

import ErrorPage from './error';

const CrmPage = ({ children, pageName }) => {
    const [error] = useState(null);

    const content =
        error && error ? (
            <ErrorPage error={error} />
        ) : (
            <section>
                <NavMenu type={pageName} />
                {children}
                <Toasts />
            </section>
        );
    return content;
};

export default CrmPage;
